module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h3 class="center">Upload Signed Document</h3>\n\n<div class="row reviewer-row well">\n    <div class="col-md-7 col-xs-7 top-margined">\n        <div class="form form-horizontal">\n            <div class="form-group col-md-4 col-xs-4">\n                <input type="text" id="barcode" class="form-control" placeholder="Barcode"/>\n            </div>\n            <div class="form-group col-md-6 col-xs-6" style="margin-left: 1px;">\n                <div id="patient-select"></div>\n            </div>\n            <div class="form-group col-md-2 col-xs-2" style="margin-left: 1px;">\n                <button id="search-documents" class="btn btn-primary" disabled>Search</button>\n            </div>\n        </div>\n    </div>\n\n    <div class="col-md-5 col-xs-5 top-margined">\n        <div id="fount-docs">No documents</div>\n    </div>\n</div>\n\n<div class="top-margined">\n    <div id="upload-form"></div>\n</div>\n\n<div id="confirmation-modal"></div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/documents/upload-signed-document-view.html
// module id = 445
// module chunks = 0